export default {
  name: 'marking--objectSendModel',
  apiService: 'shoes',
  apiPath: '/admin/object_send_model',
};